(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const glide = new Glide('#recommended-carousel', {
                type: 'carousel',
                perView: 5,
                gap: 20,
                rewind: false,
                startAt: 1,
                breakpoints: {
                  1600: {
                    perView: 5,
                  },
                  1400: {
                    perView: 4,
                    gap: 15,
                  },
                  992: {
                    perView: 3,
                    gap: 15,
                  },
                  576: {
                    perView: 2,
                    gap: 15,
                  },
                },
              });

              glide.mount();
            } else {
              document.querySelector('#product-recommendations').remove();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
window.theme = window.theme || {};
window.Shopify = window.Shopify || {};
theme.recentlyViewedIds = [];

theme.config = {
  hasSessionStorage: true,
  hasLocalStorage: true,
};

theme.isStorageSupported = function (type) {
  if (window.self !== window.top) return false;
  var testKey = 'test';
  var storage = type === 'session' ? window.sessionStorage : window.localStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.config.hasLocalStorage = theme.isStorageSupported('local');

if (theme.config.hasLocalStorage) {
  var recentIds = window.localStorage.getItem('recently-viewed');
  if (recentIds && typeof recentIds !== undefined) {
    theme.recentlyViewedIds = JSON.parse(recentIds);
  }
}

class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);

    window.addEventListener('resize', this.updateSlider.bind(this));
  }

  handleIntersection(entries, observer) {
    var id = this.dataset.productId;
    if (!id) return;

    var index = theme.recentlyViewedIds.indexOf(id);
    if (index > -1) theme.recentlyViewedIds.splice(index, 1);
    theme.recentlyViewedIds.unshift(id);

    if (theme.config.hasLocalStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(theme.recentlyViewedIds));
    }

    if (theme.recentlyViewedIds.length <= 1) return;

    var url = 'https://turfrey.co.nz/search?view=recently-viewed&type=product&q=';
    var products = '';
    var i = 0;

    theme.recentlyViewedIds.forEach(function (val) {
      if (val === id || i >= 50) return;
      products += 'id:' + val + ' OR ';
      i++;
    });

    url = url + encodeURIComponent(products);

    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        this.replaceChildren(...html.childNodes);

        requestAnimationFrame(() => {
          const carouselElement = this.querySelector('#recently-viewed-carousel');
          if (!carouselElement) {
            console.warn('recently-viewed-carousel not found');
            return;
          }
          this.updateSlider();
        });
      })
      .catch((e) => console.error(e));
  }

  updateSlider() {
    if (this.glide) {
      this.glide.destroy();
    }

    const glideArrows = this.querySelector('.glide__arrows');
    const carouselElement = this.querySelector('#recently-viewed-carousel');
    const windowWidth = window.innerWidth;

    if (!carouselElement || theme.recentlyViewedIds.length <= 1) return;

    let glideConfig = null;

    if (theme.recentlyViewedIds.length >= 3 && windowWidth <= 576) {
      glideConfig = {
        type: 'carousel',
        perView: 2,
        gap: 15,
        rewind: false,
        startAt: 0,
        breakpoints: {
          576: { perView: 2, gap: 15 },
        },
      };
    } else if (theme.recentlyViewedIds.length >= 4 && windowWidth <= 992) {
      glideConfig = {
        type: 'carousel',
        perView: 3,
        gap: 15,
        rewind: false,
        startAt: 1,
        breakpoints: {
          992: { perView: 3, gap: 15 },
          576: { perView: 2, gap: 15 },
        },
      };
    } else if (theme.recentlyViewedIds.length >= 5 && windowWidth <= 1400) {
      glideConfig = {
        type: 'carousel',
        perView: 4,
        gap: 15,
        rewind: false,
        startAt: 1,
        breakpoints: {
          1400: { perView: 4, gap: 15 },
          992: { perView: 3, gap: 15 },
          576: { perView: 2, gap: 15 },
        },
      };
    } else if (theme.recentlyViewedIds.length >= 6) {
      glideConfig = {
        type: 'carousel',
        perView: 5,
        gap: 15,
        rewind: false,
        startAt: 1,
        breakpoints: {
          1600: { perView: 5 },
          1400: { perView: 4, gap: 15 },
          992: { perView: 3, gap: 15 },
          576: { perView: 2, gap: 15 },
        },
      };
    } else {
      if (glideArrows) glideArrows.style.display = 'none';
      carouselElement.classList.add('slider-fired');
      return;
    }

    if (glideConfig) {
      this.glide = new Glide('#recently-viewed-carousel', glideConfig);
      this.glide.mount();
      carouselElement.classList.remove('slider-fired');
      if (glideArrows) glideArrows.style.display = 'block';
    }
  }
}

customElements.define('recently-viewed', RecentlyViewed);

  } catch(e) { console.error(e); }
})();
})();
